import { BaseDto } from "./base.dto";

export class PaymentMethodVerificationDto extends BaseDto {
  merchantId: number;
  paymentMethodId: number | null;
  successUrl: string;
  failUrl: string;
  merchantReference: string;
  storeCard: boolean;
  entity: string;
  webPaymentType: string;
}
